<template lang="pug">
  .bullets
    .item.xs-f-xsmall(v-for="bullet in items")
      mr-icon.mr-50m(name="heart" height="1em")
      span.xs-f-small.md-f-xsmall.cw-color-11 {{ bullet }}
  
</template>
<script>
  export default {
    name: "Bullets",
    props: {
      items: {
        type: Array,
        default: () => ([])
      }
    }
  };
</script>
<style scoped lang="stylus">
  .bullets
    display flex
    flex-direction column
    align-items flex-start
    gap 1em
    .item
      svg
        color #7186D0

</style>